import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.lib.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ClearAuthStateAction, EnrichAuthStateAction } from '../store/auth.actions';
import { AppState } from 'libs/tm-common/src/lib/store/reducers/reducers';
import { AdminSession, CustomerSession } from 'libs/tm-common/src/lib/models/user.model';
import { storeRedirectParams } from 'libs/tm-common/src/lib/store/redirect-state/redirect.actions';

@Injectable({
	providedIn: 'root'
})
export class CustomerAuthGuard implements CanActivate {
	router = inject(Router);
	private authService = inject(AuthService);
	private store = inject<Store<AppState>>(Store);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authService.getMe().pipe(
			take(1),
			map((res: CustomerSession | AdminSession | { isLoggedIn: false }) => {
				if (!res.isLoggedIn || res.tm_admin === "1") {
					this.store.dispatch(new ClearAuthStateAction());
					this.store.dispatch(storeRedirectParams({ path: state.url, queryParams: state.root.queryParams }));
					this.router.navigate(['signin']);
					return false;
				} else {
					this.store.dispatch(new EnrichAuthStateAction(res));
					return true;
				}
			})
		);
	}
}
